// extracted by mini-css-extract-plugin
export default {"column":"GalleryColumn_column__fCC4y","wide":"GalleryColumn_wide__a7M8A","thin":"GalleryColumn_thin__deEpm"};